/**
 * Age helpers. The 18+ hard floor lives here as a single constant
 * referenced everywhere age is checked.
 */

/** Minimum allowed age. Defined once; referenced by schemas + services + UI. */
export const MIN_AGE_YEARS = 18;

/**
 * Compute integer age from a YYYY-MM-DD date of birth, anchored at `now`.
 * Returns the user's age on the anniversary-already-passed basis.
 */
export function ageFromDob(dobIsoDate: string, now: Date = new Date()): number {
  const [yStr, mStr, dStr] = dobIsoDate.split('-');
  const y = Number(yStr);
  const m = Number(mStr);
  const d = Number(dStr);
  if (!Number.isFinite(y) || !Number.isFinite(m) || !Number.isFinite(d)) {
    return Number.NaN;
  }

  let age = now.getUTCFullYear() - y;
  const monthDelta = now.getUTCMonth() + 1 - m;
  if (monthDelta < 0 || (monthDelta === 0 && now.getUTCDate() < d)) {
    age -= 1;
  }
  return age;
}

/** Coarse "active recently" bucket. Centralizes the timestamp → label rule. */
export type LastActiveBucket = 'now' | 'today' | 'this_week' | 'recently' | 'old';

export function lastActiveBucket(
  lastSeenAt: Date | null,
  now: Date = new Date(),
): LastActiveBucket {
  if (!lastSeenAt) return 'old';
  const minutes = (now.getTime() - lastSeenAt.getTime()) / 60000;
  if (minutes <= 5) return 'now';
  if (minutes <= 60 * 24) return 'today';
  if (minutes <= 60 * 24 * 7) return 'this_week';
  if (minutes <= 60 * 24 * 30) return 'recently';
  return 'old';
}
